import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import PageContentWrapper from "../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../components/mui/app/pageTitle/pageTitle";
import { view_non_completed_checklists } from "../../helpers/rights/rights";
import { CHECKLISTS } from "../../locales/pages/namespaces";
import ChecklistsList from "../../modules/issues/components/nonCompletedChecklists/checklistsList";
import { withPermissionHOC } from "../../modules/permission/components/permissionHOC/permissionHOC";

const NonCompletedChecklistsIndex = (props) => {
	const { t } = useTranslation(CHECKLISTS)
	
	
	return (
		<Box className={'non_completed_checklist_index'}>
			{/*<PageMenu>*/}
			{/*	<Button*/}
			{/*		component={Link}*/}
			{/*		onClick={() => console.log('go to po page')}*/}
			{/*		// to={getRouteUrl(ROUTE_PAGE_QUESTIONNAIRE_ISSUE_ASSIGNMENT_INDEX)}*/}
			{/*		startIcon={<NavigateBefore/>}*/}
			{/*	>*/}
			{/*		{t('Return to...')}*/}
			{/*	</Button>*/}
			{/*</PageMenu>*/}
			<PageContentWrapper>
				<PageTitle title={t("Non Completed Checklists")}/>
				<ChecklistsList  Finalization={'0'} url={'questionnaire-data/index'} />
			</PageContentWrapper>
		</Box>
	);
};

export default NonCompletedChecklistsIndex
// export default withPermissionHOC(NonCompletedChecklistsIndex, [view_non_completed_checklists])